import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

export const Download = () => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 11.5V5.8C17 4.11984 17 3.27976 16.673 2.63803C16.3854 2.07354 15.9265 1.6146 15.362 1.32698C14.7202 1 13.8802 1 12.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11979 21 5.79986 21H9.5M11 10H5M7 14H5M13 6H5M12 18L15 21M15 21L18 18M15 21V15"
                    stroke="#140B1D"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.6673 15.6667V8.0667C22.6673 5.82649 22.6673 4.70639 22.2313 3.85074C21.8478 3.09809 21.2359 2.48617 20.4833 2.10268C19.6276 1.6667 18.5075 1.6667 16.2673 1.6667H7.73398C5.49377 1.6667 4.37367 1.6667 3.51802 2.10268C2.76537 2.48617 2.15345 3.09809 1.76996 3.85074C1.33398 4.70639 1.33398 5.82649 1.33398 8.0667V21.9334C1.33398 24.1736 1.33398 25.2937 1.76996 26.1493C2.15345 26.902 2.76537 27.5139 3.51802 27.8974C4.37367 28.3334 5.49371 28.3334 7.73379 28.3334H12.6673M14.6673 13.6667H6.66732M9.33398 19H6.66732M17.334 8.33337H6.66732M16.0007 24.3334L20.0006 28.3334M20.0006 28.3334L24.0006 24.3334M20.0006 28.3334V20.3334"
                    stroke="#140B1D"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={13} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" className="cursor-pointer">
            <path
                d="M11.334 8.333v-3.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218H3.867c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v6.934c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h2.467m1-7.334h-4M4.667 10H3.334m5.333-5.333H3.334m4.666 8 2 2m0 0 2-2m-2 2v-4"
                stroke="#140B1D"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
